module.exports = __webpack_public_path__ + "img/09.f1f413e6.jpg";